import ReactDOM from "react-dom/client";
import ReactGA from "react-ga4";
import App from "./App";
import "bootstrap/dist/css/bootstrap.min.css";
import "./styles/index.css";

ReactGA.initialize(process.env.REACT_APP_GOOGLE_ANALYTICS_TRACKING_ID); // Injects Google Tag Manager code
ReactDOM.createRoot(document.getElementById("root")).render(<App />);
